import * as React from "react";
import { Dialog, IconButton, DialogContent, DialogActions, Button, Table, TableHead, TableRow, TableCell, TableBody } from "@material-ui/core";
import strings from "../../utils/StringManager";
import LoadingIcon from '../../../common/components/LoadingIcon';
import "./AccessesChangesTable.css"
import DialogTitleWithClose from "../../components/DialogTitleWithClose";

export interface IAccessChangeRow {
	relationId: number,
	command: string,
	employeeId: string,
	rolePermissionId: number,
	rolePermissionName: string,
	moduleId: string,
	moduleName: string,
	applicationNameId: number,
	applicationName: string,
	beforeFrom: string,
	beforeTo: string,
	from: string,
	to: string,
	login: string,
}
type IAccessesGroups = { [key: string]: IAccessChangeRow[] };

interface IProps {
	items: IAccessChangeRow[],
	resourceName: string,
	loading?: boolean,
}

function FieldChange(props: { before: string, after: string }) {
	if (!props.before && !props.after)
		return null;
	if (props.before == props.after)
		return <>{props.after}</>;

	if (!props.before && props.after)
		return <span className="diff-add">{props.after}</span>;

	if (props.before && !props.after)
		return <span className="diff-delete">{props.before}</span>;

	return <>
		<span className="diff-delete">{props.before}</span>
		<span className="diff-add">{props.after}</span>
	</>;
}

export default function AccessesChangesTable(props: IProps) {
	if (!props.items)
		return null;

	const [open, setOpen] = React.useState(false);
	const [rows, setAccessChangeRow] = React.useState<IAccessesGroups>(null);

	function loadAccesses() {

		let rows: IAccessChangeRow[] = props.items;

		let result: IAccessesGroups = {};

		for (let i = 0; i < rows.length; i++) {
			let row = rows[i];
			let key = row.moduleName || "_";
			if (!result[key]) {
				result[key] = [];
			}

			result[key].push(row);
		}

		setAccessChangeRow(result);
	}

	React.useEffect(() => {
		loadAccesses();
	}, [props.items]);

	function handleClickOpen() {
		setOpen(true);
	}

	function handleClose() {
		setOpen(false);
	}

	let table = null;
	if (rows) {
		table = (<Table>
			<TableHead>
				<TableRow>
					<TableCell>{strings.get("action")}</TableCell>
					<TableCell>{strings.get("module")}</TableCell>
					<TableCell>{strings.get("permissionRole")}</TableCell>
					<TableCell>{strings.get("from")}</TableCell>
					<TableCell>{strings.get("to")}</TableCell>
					<TableCell>Login</TableCell>
				</TableRow>
			</TableHead>
			<TableBody>
				{Object.values(rows).map((group, i) => {
					let header = group[0];
					return <React.Fragment key={i}>
						{header.applicationName && <TableRow key={i}>
							<TableCell component="th" scope="row" colSpan={6}>System: <strong>{header.applicationName}</strong></TableCell>
						</TableRow>}

						{group.map((row, j) => <TableRow key={i + " " + j} className={"tr-access-change-" + row.command}>
							<TableCell component="th" scope="row">
								{row.command == "Add" && <span className="label label-success" >{strings.get("newAccess")}</span>}
								{row.command == "Update" && <span className="label label-warning" >{strings.get("updateAccess")}</span>}
								{row.command == "Delete" && <span className="label label-danger" >{strings.get("deleteAccess")}</span>}
							</TableCell>
							<TableCell>{row.moduleName}</TableCell>
							<TableCell>{row.rolePermissionName}</TableCell>
							<TableCell>
								<FieldChange before={row.beforeFrom} after={row.from} />
							</TableCell>
							<TableCell>
								<FieldChange before={row.beforeTo} after={row.to} />
							</TableCell>
							<TableCell>{row.login}</TableCell>
						</TableRow>)
						}</React.Fragment>
				})}
			</TableBody>
		</Table>);
	}


	return <div>
		<IconButton onClick={handleClickOpen} className="mi-button-icon" title={strings.get("accessesChangesForPersonProfile")}>
			<i className="material-icons">
				verified_user
			</i>
		</IconButton>
		<Dialog
			fullWidth={true}
			maxWidth={"lg"}

			open={open}
			onClose={handleClose}
		>
			<DialogTitleWithClose onClose={handleClose} >
				Zmiany dostępów dla stanowiska <strong>{props.resourceName}</strong>
			</DialogTitleWithClose>
			<DialogContent>
				{props.loading && <div className="text-center"><LoadingIcon /></div>}
				{table}
			</DialogContent>
			<DialogActions>
				<Button onClick={handleClose} autoFocus>
					{strings.get("close")}
				</Button>
			</DialogActions>
		</Dialog>
	</div>;
}